// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xzbs","option":"styles_option__1cP3E","active":"styles_active__18wT3"};